import React, {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import {postDanai} from "../../util/ajax";

function MediaInformasi() {
    const [promoEvent, setPromoEvents] = useState([])
    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/promoEvents', function (resp) {
            console.log(resp);
            setPromoEvents(resp.data);
        }, function () {
        });
    }, []);
    const promoCategory = promoEvent.map((_, index) => (
        promoEvent[index].category
    ));
    const uniqueNames = promoCategory.filter((val, id, array) => array.indexOf(val) === id);

    const [searchParams] = useSearchParams();
    const category = searchParams.get("category");
    let dataOneCategory;
    if (category !== null) {
        dataOneCategory = promoEvent.filter(data => data.category === category);
    } else {
        dataOneCategory = promoEvent;
    }
    console.log(dataOneCategory);

    return (
        <>
            <article className="event-promo">
                <div className="general-container">
                    <header>
                        <div className="ui-g-12">
                            <ul className="breadcrumb">
                                <li><Link to="/">Beranda</Link></li>
                                <li>Media Informasi</li>
                            </ul>
                        </div>
                    </header>

                    <div className="category-new">
                        <div className="category-list-new">
                            <Link to='/media-informasi' className={`${category === null ? 'active' : ''}`}>Semua</Link>
                        </div>
                        {Array.from({length: uniqueNames.length}).map((_, index) => (
                                <div className="category-list-new">
                                    <Link to={{pathname: '/media-informasi', search: `?category=${uniqueNames[index]}`}}
                                          className={`${category === uniqueNames[index] ? 'active' : ''}`}>{uniqueNames[index]}</Link>
                                </div>
                            )
                        )}
                    </div>
                    <div className="event-wrapper">
                        <div className="ui-g product-item">
                            {Array.from({length: dataOneCategory.length}).map((_, index) => (
                                <div className="ui-g-12 ui-md-6 ui-lg-3 card">
                                    <div className="clickable">
                                        <img src={dataOneCategory[index].imageUrl} alt="promo"/>
                                        <a type="button" style={{whiteSpace: "nowrap"}}
                                           className="btn-event">{dataOneCategory[index].category}</a>
                                        <h4>{dataOneCategory[index].title}</h4>
                                        <div className="desc-card"
                                             dangerouslySetInnerHTML={{__html: dataOneCategory[index].content}}/>
                                    </div>
                                    <div className="btn-read-more">
                                        <Link preventScrollReset={true} className="btn" to={{
                                            pathname: '/promo-detail',
                                            search: `?id=${dataOneCategory[index].id}`
                                        }}>Baca Selengkapnya</Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}

export default MediaInformasi;